import { CheckCircle2 } from "lucide-react";

const MarketingContent = (): JSX.Element => {
  return (
    <div className="flex flex-1 flex-col justify-center">
      <div className="flex max-w-[600px] flex-col items-start gap-6">
        {/* Badge */}
        <span className="inline-flex items-center gap-2 rounded-full bg-purple-100 px-3 py-1 text-sm text-purple-700">
          <CheckCircle2 className="size-4" />
          Agente IA 24/7
        </span>

        {/* Headline */}
        <h1 className="text-[2rem] font-bold leading-[1.1] md:text-[3.5rem]">
          Automatiza tus ventas con{" "}
          <span className="text-purple-600">
            Inteligencia Artificial
          </span>
        </h1>

        {/* Description */}
        <p className="text-lg leading-relaxed text-gray-600">
          Crea tu agente IA personalizado que atiende clientes, califica leads y gestiona citas automáticamente
        </p>

        {/* Benefits list */}
        <div className="mt-4 flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <CheckCircle2 className="size-6 text-purple-600" />
            <p>Configura tu agente en menos de 5 minutos</p>
          </div>
          <div className="flex items-center gap-3">
            <CheckCircle2 className="size-6 text-purple-600" />
            <p>Respuestas automáticas 24/7</p>
          </div>
          <div className="flex items-center gap-3">
            <CheckCircle2 className="size-6 text-purple-600" />
            <p>Integración con WhatsApp Business</p>
          </div>
          <div className="flex items-center gap-3">
            <CheckCircle2 className="size-6 text-purple-600" />
            <p>Análisis de conversaciones en tiempo real</p>
          </div>
        </div>

        {/* Testimonial */}
        <div className="mt-8 max-w-[500px] rounded-lg bg-white p-6">
          <div className="mb-3 flex gap-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <span key={star} className="text-xl text-yellow-400">⭐</span>
            ))}
          </div>
          <p className="mb-3 italic">
            Con la IA de Palomma hemos aumentado nuestra conversión de contacto a cierre de negocios en un 30%. Ahora podemos ofrecer una atención inmediata, 24/7 y conversacional a nuestros clientes. ¡Es lo mejor que nos ha pasado!
          </p>
          <p className="text-sm text-gray-600">
            — Oscar Ortiz, Umbral Propiedad Raíz
          </p>
        </div>
      </div>
    </div>
  );
};

export default MarketingContent;
